import React, { useState } from 'react';
import { Button } from 'anf-core-react';
import PropTypes from 'prop-types';
import CancelReturnExchangeModal from '../../OrderHistory/CancelReturnExchangeModal';
import { textProp } from '../../../tools/customProps';
import TmntText from '../../Common/Text/TmntText';

export default function CancelRnEControls({ email, orderNumber, label }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Button
        isFullWidth
        onClick={() => setIsOpen(true)}
        variant="tertiary-light"
      >
        <TmntText tmnt={label} />
      </Button>
      <CancelReturnExchangeModal
        email={email}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        orderNumber={orderNumber}
      />
    </>
  );
}

CancelRnEControls.propTypes = {
  email: PropTypes.string.isRequired,
  label: textProp.isRequired,
  orderNumber: PropTypes.string.isRequired,
};
